import { CheckCircle } from '#assets/ReactSvg.ts';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { useCapabilities } from '#global/context/capabilities/useCapabilities.ts';

export function PriorityBanner() {
  const { capabilities } = useCapabilities();

  if (capabilities?.prioritySupport) {
    return (
      <Banner variant="success" Icon={CheckCircle} iconClassName="color-success">
        Priority support active
      </Banner>
    );
  }
  return (
    <Banner variant="default" Icon={CheckCircle}>
      Standard support active{' '}
      <Link to="/settings/billing" className="a">
        Upgrade to Pro
      </Link>
    </Banner>
  );
}
